<template>
  <div class="bottomBlock">
    <div class="leftArrow">
      <img class="lArrowImg" src="../../../../../static/img/20.png" alt="" />
      <div class="totalBar"><patentAll></patentAll></div>
      <div class="total">
        <!-- <PCT></PCT> -->
        <!-- <div class="total-title">
          <img src="/static/img/28.png" alt="" />
          <span> PCT专利统计 </span>
          <img src="/static/img/21.png" alt="" />
        </div> -->
        <PCT></PCT>
      </div>
    </div>
    <div class="rightArrow">
      <div class="total">
        <!-- <div class="total-title">
          <img src="/static/img/28.png" alt="" />
          <span> 申请人合作情况 </span>
          <img src="/static/img/21.png" alt="" />
        </div> -->
        <Cooperte></Cooperte>
        <div class="total-graph"></div>
      </div>
      <div class="totalBar"><inventor></inventor></div>
      <img class="rArrowImg" src="../../../../../static/img/27.png" alt="" />
    </div>
  </div>
</template>
<script>
import patentAll from './patentAll'
import inventor from './inventor'
import PCT from './PCT/index.vue'
import Cooperte from './Cooperate/index.vue'
export default {
  data() {
    return {}
  },
  components: {
    patentAll,
    inventor,
    PCT,
    Cooperte
  }
}
</script>
